import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  quote: "Their psychiatrist's PTSD report was instrumental in securing a six-figure RTA settlement. The depth of analysis was exceptional.",
  author: 'Senior Partner',
  role: 'Top 100 UK Law Firm'
}, {
  quote: 'Screening report identified breach within 3 weeks, saving us months of investigation. A highly efficient service for clinical negligence cases.',
  author: 'Head of Litigation',
  role: 'Regional Practice'
}, {
  quote: "The orthopaedic expert's causation analysis withstood rigorous cross-examination. We rely on their panel for our most complex multi-track cases.",
  author: 'Claims Manager',
  role: 'National Insurer'
}];
export function TestimonialsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 8000);
    return () => clearInterval(timer);
  }, []);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-10 bg-warm-50 overflow-hidden border-t border-warm-200" aria-label="Client testimonials from legal professionals" data-id="element-436">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-437">
        <div className="text-center mb-8" data-id="element-438">
          <h2 className="text-3xl md:text-4xl font-bold text-ink-900 tracking-tight" data-id="element-439">
            Trusted by Legal Professionals
          </h2>
        </div>

        <div className="relative max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 border border-warm-200 shadow-sm" data-id="element-440">
          <Quote className="absolute top-8 left-8 h-12 w-12 text-teal-100 -z-0" data-id="element-441" />

          <div className="relative z-10 min-h-[200px] flex items-center justify-center" data-id="element-442">
            <AnimatePresence mode="wait" data-id="element-443">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="text-center" data-id="element-444">
                <p className="text-xl md:text-2xl text-ink-700 font-medium mb-8 leading-relaxed" data-id="element-445">
                  "{testimonials[currentIndex].quote}"
                </p>
                <div data-id="element-446">
                  <div className="font-bold text-ink-900 text-lg" data-id="element-447">
                    {testimonials[currentIndex].author}
                  </div>
                  <div className="text-sm font-medium text-ink-500 uppercase tracking-wide mt-1" data-id="element-448">
                    {testimonials[currentIndex].role}
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center items-center space-x-6 mt-10" data-id="element-449">
            <button onClick={prev} className="p-2.5 rounded-full bg-white border border-warm-200 hover:bg-warm-50 hover:border-teal-300 text-ink-500 transition-colors" aria-label="Previous testimonial" data-id="element-450">
              <ChevronLeft className="h-5 w-5" data-id="element-451" />
            </button>
            <div className="flex items-center space-x-3" data-id="element-452">
              {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-teal-500' : 'bg-warm-300 hover:bg-warm-400'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-453" />)}
            </div>
            <button onClick={next} className="p-2.5 rounded-full bg-white border border-warm-200 hover:bg-warm-50 hover:border-teal-300 text-ink-500 transition-colors" aria-label="Next testimonial" data-id="element-454">
              <ChevronRight className="h-5 w-5" data-id="element-455" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}